import React, { Component, Fragment } from 'react';
import classes from './Layout.module.css';
// import Navbar from '../../components/UI/Navbar/Navbar';
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';
//import {Container} from 'react-bootstrap';
class Layout extends Component {
    state = {

    }
    handleOnLogout = () => {
        this.props.onLogoutCleanUser();
        this.props.onlogoutCleanChats();
        window.location.reload();
    }
    render() {
        return (
            <Fragment>
                <div className={classes.Layout}>

                    {this.props.isLogged ?
                        null//<Navbar logoutClicked={this.handleOnLogout} />
                        :
                        null
                    }
                    <main className={classes.Content}>
                        {this.props.children}
                    </main>


                </div>
            </Fragment>
        )
    }
}

const mapStateToProps = state => {
    return {
        isLogged: state.login.token !== null
    };

}

const mapDispatchToProps = dispatch => {
    return {
        onLogoutCleanUser: () => dispatch(actions.logout()),
        onlogoutCleanChats: () => dispatch(actions.logoutMsgs())
    }

}


export default connect(mapStateToProps, mapDispatchToProps)(Layout);